import { flattenClinicCreateData } from '@/pages/admin/site-admin-clinic-info/clinicFormSchema';
import { apiClient } from '@/shared/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

type Response<T> = {
  data: T;
};

type FlattenedClinicData = ReturnType<typeof flattenClinicCreateData>;

export const getClinicInfoDetail = async (
  id: string,
  siteType: string | null
): Promise<Response<FlattenedClinicData>> => {
  const response = await apiClient.get<Response<FlattenedClinicData>>(
    `/admin/${siteType}/clinic-informations/${id}`
  );
  return response.data;
};

export const useSiteAdminClinicInfoDetail = (id: string) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['clinic-info-detail', id, currentSite],
    queryFn: () => getClinicInfoDetail(id, currentSite),
    enabled: !!currentSite && !!id,
  });
};
